var amdi18n={"__root":{"webfonts_loading":"Loading web fonts...","images_loading":"Loading images...","get_attribute_definitions":"Loading attribute definitions...","openecard_supported_cards_prototols":"Loading Open eCard metadata...","get_options":"Loading options...","eid_client_detection":"Detecting eID-Clients...","get_cloud_identity_options":"Loading Cloud Identity options...","get_cloud_identity":"Loading Cloud Identity...","done":" done"},"__de":{"webfonts_loading":"Lade Web-Schriftarten...","images_loading":"Lade Bilder...","get_attribute_definitions":"Lade Attribut-Definitionen...","openecard_supported_cards_prototols":"Lade Open eCard Metadaten...","get_options":"Lade Optionen...","eid_client_detection":"Suche eID-Clients...","get_cloud_identity_options":"Lade Cloud Identitäts-Optionen...","get_cloud_identity":"Lade Cloud Identität...","done":" fertig"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/InitializationState_strings.js
// module id = 308
// module chunks = 2